import React from 'react';
import Button from '../../../../../generic-components/Button';
import Heading from '../../../../../generic-components/Heading';
import { UserMessage } from '../../../../../DesignSystem/LiliUserMessage/UserMessage';
import { CloseButton } from '../../../../../DesignSystem/LiliCloseButton/CloseButton';

interface IProps {
  onClosePopup: () => void;
  onCloseWizard: () => void;
}

export const LeaveCreationPopup = ({ onClosePopup, onCloseWizard }: IProps) => (
  <UserMessage onClick={onClosePopup} id='confirmCloseMessage'>
    <div className='w-[428px] py-[24px] bg-bw00 px-[24px] rounded-[8px] border border-bw03 relative flex flex-col'>
      <CloseButton onClick={onClosePopup} id='closeConfirmation' className='absolute right-[12px] top-[12px]' />
      <Heading title='Are you sure?' className='font-metricR text-[24px] text-bw08 leading-[130%] mb-[8px]' />
      <Heading
        title={'Your bill isn\'t finished yet. This draft will not be saved.'}
        className='font-metricR text-[16px] text-bw07 leading-[128%] mb-[26px]'
      />
      <div className='w-full flex items-center justify-end gap-[12px]'>
        <Button
          shouldInvertLoaderColor
          onClick={onClosePopup}
          className='bg-action00 hover:bg-action01 py-[11px] px-[40px] font-metricR text-[14px] text-action03 rounded-[4px]'
          title='Stay'
          id='stayOnPage'
        />
        <Button
          onClick={onCloseWizard}
          className='bg-red02 hover:bg-red01 py-[11px] px-[40px] font-metricR text-[14px] text-bw00 rounded-[4px]'
          title='Leave'
          id='leavePage'
        />
      </div>
    </div>
  </UserMessage>
);
